import { createSelector } from '@reduxjs/toolkit';

import { CRAFTSMAN_QUALITY_FOOTNOTE } from '../../../modules/commentary/consts.ts';
import { selectAdditionalStructureCommentaryTableDisplay, selectArvAdditionalStructureCommentaryTableDisplay } from './commentarySelectors/selectAdditionalStructureCommentary.ts';
import { selectArvConditionCommentaryTableDisplay, selectConditionCommentaryTableDisplay } from './commentarySelectors/selectConditionCommentary.ts';
import { selectExternalDepreciationCommentaryTableDisplay } from './commentarySelectors/selectExternalDepreciationCommentary.ts';
import { selectFunctionalDepreciationCommentaryTableDisplay } from './commentarySelectors/selectFunctionalDepreciationCommentary.ts';
import { selectArvMainDwellingCostsCommentaryDisplay, selectMainDwellingCostsCommentaryDisplay } from './commentarySelectors/selectMainDwellingCostsCommentary.ts';
import { selectMarketAdjustmentsCommentaryData } from './commentarySelectors/selectMarketAdjustmentsCommentary.ts';
import { selectArvQualityCommentaryTableDisplay, selectQualityCommentaryTableDisplay } from './commentarySelectors/selectQualityCommentary.ts';
import { selectSiteExtractionCommentaryTableDisplay } from './commentarySelectors/selectSiteExtractionCommentary.ts';

export const selectAllAdjustmentsTableData = createSelector(
  [
    selectMarketAdjustmentsCommentaryData,
    selectSiteExtractionCommentaryTableDisplay,
    selectMainDwellingCostsCommentaryDisplay,
    selectQualityCommentaryTableDisplay,
    selectConditionCommentaryTableDisplay,
    selectFunctionalDepreciationCommentaryTableDisplay,
    selectExternalDepreciationCommentaryTableDisplay,
    selectAdditionalStructureCommentaryTableDisplay,
  ],
  (
    marketAdjustments,
    siteExtraction,
    mainDwelling,
    quality,
    condition,
    functionalDepreciation,
    externalDepreciation,
    additionalStructures,
  ) => ({
    siteExtraction: siteExtraction.data,
    ...(marketAdjustments && {
      marketAdjustments: {
        method: marketAdjustments.method,
        tableData: marketAdjustments.table,
        commentary: marketAdjustments.commentary,
      },
      listToSale: {
        method: marketAdjustments.listToSaleMethod,
        ratio: marketAdjustments.listToSaleRatio,
        tableData: marketAdjustments.comparableSalesDataTable,
        commentary: marketAdjustments.commentary,
      },
    }),
    mainDwelling,
    quality: {
      data: quality.data,
      helperText: quality.helperText?.concat(`\n${CRAFTSMAN_QUALITY_FOOTNOTE}`),
    },
    condition,
    functionalDepreciation,
    externalDepreciation,
    additionalStructures,
  }),
);

export const selectAllArvAdjustmentsTableData = createSelector(
  [
    selectMarketAdjustmentsCommentaryData,
    selectSiteExtractionCommentaryTableDisplay,
    selectArvMainDwellingCostsCommentaryDisplay,
    selectArvQualityCommentaryTableDisplay,
    selectArvConditionCommentaryTableDisplay,
    selectFunctionalDepreciationCommentaryTableDisplay,
    selectExternalDepreciationCommentaryTableDisplay,
    selectArvAdditionalStructureCommentaryTableDisplay,
  ],
  (
    marketAdjustments,
    siteExtraction,
    mainDwelling,
    quality,
    condition,
    functionalDepreciation,
    externalDepreciation,
    additionalStructures,
  ) => ({
    siteExtraction: siteExtraction.data,
    ...(marketAdjustments && {
      marketAdjustments: {
        method: marketAdjustments.method,
        tableData: marketAdjustments.table,
        commentary: marketAdjustments.commentary,
      },
      listToSale: {
        method: marketAdjustments.listToSaleMethod,
        ratio: marketAdjustments.listToSaleRatio,
        tableData: marketAdjustments.comparableSalesDataTable,
        commentary: marketAdjustments.commentary,
      },
    }),
    mainDwelling,
    quality: {
      data: quality.data,
      helperText: quality.helperText?.concat(`\n${CRAFTSMAN_QUALITY_FOOTNOTE}`),
    },
    condition,
    functionalDepreciation,
    externalDepreciation,
    additionalStructures,
  }),
);
